"use client";

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { ApiQuotedDrop } from "@/generated/models/ApiQuotedDrop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { commonApiFetch } from "@/services/api/common-api";
import { useEffect, useState } from "react";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import DropPart from "@/components/drops/view/part/DropPart";
import { DropPartSize } from "@/components/drops/view/part/DropPart.types";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ProfileMinWithoutSubs } from "@/helpers/ProfileTypes";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface PartConfigWave {
  readonly name: string;
  readonly image: string | null;
  readonly id: string;
}
interface PartConfig {
  readonly dropId: string;
  readonly part: ApiDropPart;
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly mentionedGroups: Array<ApiDropGroupMention>;
  readonly mentionedWaves: Array<ApiMentionedWave>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly createdAt: number;
  readonly wave: PartConfigWave;
  readonly dropTitle: string | null;
}
export default function CreateDropStormViewPartQuote(t0) {
  const $ = _c(21);
  const {
    profile,
    quotedDrop
  } = t0;
  let t1;
  let t2;
  if ($[0] !== quotedDrop.drop_id) {
    t1 = [QueryKey.DROP, quotedDrop.drop_id];
    t2 = async () => await commonApiFetch({
      endpoint: `/drops/${quotedDrop.drop_id}`
    });
    $[0] = quotedDrop.drop_id;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = typeof quotedDrop.drop_id === "string";
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      placeholderData: keepPreviousData
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: drop
  } = useQuery(t4);
  let t5;
  if ($[7] !== drop || $[8] !== quotedDrop.drop_part_id) {
    t5 = () => {
      if (!drop) {
        return null;
      }
      const part_0 = drop.parts.find(part => part.part_id === quotedDrop.drop_part_id);
      if (!part_0) {
        return null;
      }
      return {
        dropId: drop.id,
        part: part_0,
        mentionedUsers: drop.mentioned_users,
        mentionedGroups: drop.mentioned_groups,
        mentionedWaves: drop.mentioned_waves,
        referencedNfts: drop.referenced_nfts,
        createdAt: drop.created_at,
        dropTitle: drop.title,
        wave: {
          name: drop.wave.name,
          image: drop.wave.picture,
          id: drop.wave.id
        }
      };
    };
    $[7] = drop;
    $[8] = quotedDrop.drop_part_id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const getPartConfig = t5;
  let t6;
  if ($[10] !== getPartConfig) {
    t6 = getPartConfig();
    $[10] = getPartConfig;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const [partConfig, setPartConfig] = useState(t6);
  let t7;
  if ($[12] !== getPartConfig) {
    t7 = () => setPartConfig(getPartConfig());
    $[12] = getPartConfig;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== drop) {
    t8 = [drop];
    $[14] = drop;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t9;
  if ($[16] !== partConfig || $[17] !== profile) {
    t9 = !!partConfig && <DropPart dropId={partConfig.dropId} profile={profile} mentionedUsers={partConfig.mentionedUsers} mentionedGroups={partConfig.mentionedGroups} mentionedWaves={partConfig.mentionedWaves} referencedNfts={partConfig.referencedNfts} smallMenuIsShown={false} partContent={partConfig.part.content ?? null} partMedias={partConfig.part.media.map(_temp)} createdAt={partConfig.createdAt} wave={partConfig.wave} dropTitle={partConfig.dropTitle} size={DropPartSize.SMALL} />;
    $[16] = partConfig;
    $[17] = profile;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <div className="tw-mt-2 tw-w-full tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-p-2">{t9}</div>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp(media) {
  return {
    mimeType: media.mime_type,
    mediaSrc: media.url
  };
}